var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-clamp',{class:[
    'asc-required-label',
    _vm.required ? 'is__required' : null,
    _vm.uppercase ? 'text-uppercase' : null ],attrs:{"autoresize":"","max-lines":1},scopedSlots:_vm._u([(_vm.required)?{key:"after",fn:function(){return [_vm._t("beforeRequired"),_c('span',{staticClass:"required"},[_vm._v("required")])]},proxy:true}:null],null,true)},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }